import React from 'react'
import {Modal, Button} from 'react-bootstrap';
import CircleCloseIcon from "../../assets/images/CircleCloseIcon.svg"
import "./style.css";

const {Header, Body } = Modal

const bgColors = {
    success: "#78A22F",
    error: "#C43131",
    warning: "#EDEDED",
    plain: ''
  }

type modalSiZe = "sm" | "lg" | "xl";
type modalVariant = "success" | "error"  | "warning" | "plain";

interface ModalProps {
    type: modalVariant;
    title: string;
    children: any;
    size?: modalSiZe;
    show: boolean;
    enableFooter: boolean;
    btnText?: string;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
    onConfirmModal?: () => void;

}
const ModalComponent: React.FC<ModalProps> = ({type, title, children, size, enableFooter, btnText, show, setShow, onConfirmModal}) => {
  return (
    <Modal
        show={show}
        size={size}
        dialogClassName="view-doc-upload-modal"
    >
        <Header 
        style={{
            backgroundColor: type !== "plain" ? bgColors[type] : "none",
            padding: "3px",
          }}>
          </Header>
        <Body className='modal-body-container'>
          <div className='modal-head'>
          <h3 >{title}</h3>
          { !enableFooter &&
          <img 
            className='modal-img'
            src={CircleCloseIcon}
            alt="Modal Icon"
            onClick={() => setShow(false)}
            /> }
          </div>
          <p className='modal-head-divider'></p>
            {children}
            { enableFooter &&
            <div className='modal-foot'>
            <Button
                className="modal-cancel-btn"
                onClick={() => setShow(false)}>
                Cancel
              </Button>
              <Button className="modal-confirm-btn" style={{ backgroundColor: bgColors[type] }} onClick={onConfirmModal}>{btnText}</Button>
            </div>
            }
            </Body>

        
    </Modal>
  )
}

export default ModalComponent